import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { includes } from 'lodash';

// import { Logger } from './logger.service';
// import * as enUS from 'en-US.json';
// import * as inBH from 'in-BH.json';


// const log = new Logger('I18nService');
const languageKey = 'language';

/**
 * Pass-through function to mark a string for translation extraction.
 * Running `npm translations:extract` will include the given string by using this.
 * @param {string} s The string to extract for translation.
 * @return {string} The same string.
 */
export function extract(s: string) {
  return s;
}

@Injectable()
export class I18nService {

  defaultLanguage: string;
  supportedLanguages: string[];

  public enUS = {
    "ABC": "ABC - EN",
    "AEGIS ID": "AEGIS ID - EN",
    "Acquisition Cost": "Acquisition Cost - EN",
    "Actions": "Actions - EN",
    "Add Agent": "Add Agent - EN",
    "Add field": "Add field - EN",
    "Address (Line 1)": "Address (Line 1) - EN",
    "Address (Line 2)": "Address (Line 2) - EN",
    "Address Line 1": "Address Line 1 - EN",
    "Address Line 2": "Address Line 2 - EN",
    "Agent": "Agent - EN",
    "Agent Category": "Agent Category - EN",
    "Agent Type": "Agent Type - EN",
    "Agents": "Agents - EN",
    "Associated Agent": "Associated Agent - EN",
    "Basic Details": "Basic Details - EN",
    "Branch": "Branch - EN",
    "Branch Name": "Branch Name - EN",
    "CGISS ID": "CGISS ID - EN",
    "Channel": "Channel - EN",
    "Check all": "Check all - EN",
    "Choose Roles": "Choose Roles - EN",
    "City": "City - EN",
    "Commission": "Commission - EN",
    "Commission Distribution": "Commission Distribution - EN",
    "Company": "Company - EN",
    "Company Name": "Company Name - EN",
    "Contact Person": "Contact Person - EN",
    "Continue": "Continue - EN",
    "Copy": "Copy - EN",
    "Copy reporting structure of": "Copy reporting structure of - EN",
    "Country": "Country - EN",
    "Designation": "Designation - EN",
    "Details": "Details - EN",
    "Division": "Division - EN",
    "Edit": "Edit - EN",
    "Edit details for": "Edit details for - EN",
    "Email ID": "Email ID - EN",
    "Employee ID": "Employee ID - EN",
    "First Name": "First Name - EN",
    "Hello world !": "Hello world ! - EN",
    "Hierarchy": "Hierarchy - EN",
    "Individual Agent": "Individual Agent - EN",
    "Insurance Company Details": "Insurance Company Details - EN",
    "Integral ID": "Integral ID - EN",
    "Last Name": "Last Name - EN",
    "License Expiry Date": "License Expiry Date - EN",
    "License Issue Date": "License Issue Date - EN",
    "License No": "License No - EN",
    "License Validity": "License Validity - EN",
    "Login": "Login - EN",
    "Max": "Max - EN",
    "Max Acquisition Cost": "Max Acquisition Cost - EN",
    "Max Acquisition and Commission Distribution": "Max Acquisition and Commission Distribution - EN",
    "Mobile Number": "Mobile Number - EN",
    "Move selected": "Move selected - EN",
    "Name": "Name - EN",
    "Organization": "Organization - EN",
    "Partner Name": "Partner Name - EN",
    "Password": "Password - EN",
    "Person": "Person - EN",
    "Postal Code": "Postal Code - EN",
    "Product": "Product - EN",
    "Province": "Province - EN",
    "Remove": "Remove - EN",
    "Reportees of": "Reportees of - EN",
    "Reporting": "Reporting - EN",
    "Reporting Manager": "Reporting Manager - EN",
    "Reporting structure of": "Reporting structure of - EN",
    "Roles": "Roles - EN",
    "Save": "Save - EN",
    "Select Branch": "Select Branch - EN",
    "Select Category": "Select Category - EN",
    "Select Channel": "Select Channel - EN",
    "Select City": "Select City - EN",
    "Select Company": "Select Company - EN",
    "Select Contact Person": "Select Contact Person - EN",
    "Select Country": "Select Country - EN",
    "Select Designation": "Select Designation - EN",
    "Select Division": "Select Division - EN",
    "Select Product": "Select Product - EN",
    "Select Province": "Select Province - EN",
    "Select Status": "Select Status - EN",
    "Select Sub-Channel": "Select Sub-Channel - EN",
    "Select Sub-Division": "Select Sub-Division - EN",
    "Select an Agent": "Select an Agent - EN",
    "Status": "Status - EN",
    "Sub Channel": "Sub Channel - EN",
    "Sub-Division": "Sub-Division - EN",
    "Type": "Type - EN",
    "Update": "Update - EN",
    "Update Reporting": "Update Reporting - EN",
    "Use your credentials and login to MMS' Insurance functions on the cloud": "Use your credentials and login to MMS' Insurance functions on the cloud - EN",
    "Username": "Username - EN",
    "VAT Applicability": "VAT Applicability - EN",
    "Work Number": "Work Number - EN",
    "reporting": "reporting - EN",
    "reporting structure to": "reporting structure to - EN",
    "reports to": "reports t - ENo"
  }

  public inBH = {
  "ABC": "ABC - BH",
  "AEGIS ID": "AEGIS ID - BH",
  "Acquisition Cost": "Acquisition Cost - BH",
  "Actions": "Actions - BH",
  "Add Agent": "Add Agent - BH",
  "Add field": "Add field - BH",
  "Address (Line 1)": "Address (Line 1) - BH",
  "Address (Line 2)": "Address (Line 2) - BH",
  "Address Line 1": "Address Line 1 - BH",
  "Address Line 2": "Address Line 2 - BH",
  "Agent": "Agent - BH",
  "Agent Category": "Agent Category - BH",
  "Agent Type": "Agent Type - BH",
  "Agents": "Agents - BH",
  "Associated Agent": "Associated Agent - BH",
  "Basic Details": "Basic Details - BH",
  "Branch": "Branch - BH",
  "Branch Name": "Branch Name - BH",
  "CGISS ID": "CGISS ID - BH",
  "Channel": "Channel - BH",
  "Check all": "Check all - BH",
  "Choose Roles": "Choose Roles - BH",
  "City": "City - BH",
  "Commission": "Commission - BH",
  "Commission Distribution": "Commission Distribution - BH",
  "Company": "Company - BH",
  "Company Name": "Company Name - BH",
  "Contact Person": "Contact Person - BH",
  "Continue": "Continue - BH",
  "Copy": "Copy - BH",
  "Copy reporting structure of": "Copy reporting structure of - BH",
  "Country": "Country - BH",
  "Designation": "Designation - BH",
  "Details": "Details - BH",
  "Division": "Division - BH",
  "Edit": "Edit - BH",
  "Edit details for": "Edit details for - BH",
  "Email ID": "Email ID - BH",
  "Employee ID": "Employee ID - BH",
  "First Name": "First Name - BH",
  "Hello world !": "Hello world ! - BH",
  "Hierarchy": "Hierarchy - BH",
  "Individual Agent": "Individual Agent - BH",
  "Insurance Company Details": "Insurance Company Details - BH",
  "Integral ID": "Integral ID - BH",
  "Last Name": "Last Name - BH",
  "License Expiry Date": "License Expiry Date - BH",
  "License Issue Date": "License Issue Date - BH",
  "License No": "License No - BH",
  "License Validity": "License Validity - BH",
  "Login": "Login - BH",
  "Max": "Max - BH",
  "Max Acquisition Cost": "Max Acquisition Cost - BH",
  "Max Acquisition and Commission Distribution": "Max Acquisition and Commission Distribution - BH",
  "Mobile Number": "Mobile Number - BH",
  "Move selected": "Move selected - BH",
  "Name": "Name - BH",
  "Organization": "Organization - BH",
  "Partner Name": "Partner Name - BH",
  "Password": "Password - BH",
  "Person": "Person - BH",
  "Postal Code": "Postal Code - BH",
  "Product": "Product - BH",
  "Province": "Province - BH",
  "Remove": "Remove - BH",
  "Reportees of": "Reportees of - BH",
  "Reporting": "Reporting - BH",
  "Reporting Manager": "Reporting Manager - BH",
  "Reporting structure of": "Reporting structure of - BH",
  "Roles": "Roles - BH",
  "Save": "Save - BH",
  "Select Branch": "Select Branch - BH",
  "Select Category": "Select Category - BH",
  "Select Channel": "Select Channel - BH",
  "Select City": "Select City - BH",
  "Select Company": "Select Company - BH",
  "Select Contact Person": "Select Contact Person - BH",
  "Select Country": "Select Country - BH",
  "Select Designation": "Select Designation - BH",
  "Select Division": "Select Division - BH",
  "Select Product": "Select Product - BH",
  "Select Province": "Select Province - BH",
  "Select Status": "Select Status - BH",
  "Select Sub-Channel": "Select Sub-Channel - BH",
  "Select Sub-Division": "Select Sub-Division - BH",
  "Select an Agent": "Select an Agent - BH",
  "Status": "Status - BH",
  "Sub Channel": "Sub Channel - BH",
  "Sub-Division": "Sub-Division - BH",
  "Type": "Type - BH",
  "Update": "Update - BH",
  "Update Reporting": "Update Reporting - BH",
  "Use your credentials and login to MMS' Insurance functions on the cloud": "Use your credentials and login to MMS' Insurance functions on the cloud - BH",
  "Username": "Username - BH",
  "VAT Applicability": "VAT Applicability - BH",
  "Work Number": "Work Number - BH",
  "reporting": "reporting - BH",
  "reporting structure to": "reporting structure to - BH",
  "reports to": "reports t - ENo"
}

constructor(private translateService: TranslateService) {
  // Embed languages to avoid extra HTTP requests    
}

/**
 * Initializes i18n for the application.
 * Loads language from local storage if present, or sets default language.
 * @param {!string} defaultLanguage The default language to use.
 * @param {Array.<String>} supportedLanguages The list of supported languages.
 */
init(defaultLanguage: string, supportedLanguages: string[]) {
  this.defaultLanguage = defaultLanguage;
  this.supportedLanguages = supportedLanguages;
  this.language = '';

  this.translateService.onLangChange
    .subscribe((event: LangChangeEvent) => { localStorage.setItem(languageKey, event.lang); });
}

/**
 * Sets the current language.
 * Note: The current language is saved to the local storage.
 * If no parameter is specified, the language is loaded from local storage (if present).
 * @param {string} language The IETF language code to set.
 */
set language(language: string) {
  language = language || localStorage.getItem(languageKey) || this.translateService.getBrowserCultureLang();
  let isSupportedLanguage = includes(this.supportedLanguages, language);

  // If no exact match is found, search without the region
  if (language && !isSupportedLanguage) {
    language = language.split('-')[0];
    language = this.supportedLanguages.find(supportedLanguage => supportedLanguage.startsWith(language)) || '';
    isSupportedLanguage = Boolean(language);
  }

  // Fallback if language is not supported
  if (!isSupportedLanguage) {
    language = this.defaultLanguage;
  }

  // log.debug(`Language set to ${language}`);
  this.translateService.use(language);
}

/**
 * Gets the current language.
 * @return {string} The current language code.
 */
get language(): string {
  return this.translateService.currentLang;
}

}
